"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ClickAwayListener_1 = require("@material-ui/core/ClickAwayListener");
var Fab_1 = require("@material-ui/core/Fab");
var Grid_1 = require("@material-ui/core/Grid");
var Grow_1 = require("@material-ui/core/Grow");
var ListSubheader_1 = require("@material-ui/core/ListSubheader");
var MenuItem_1 = require("@material-ui/core/MenuItem");
var MenuList_1 = require("@material-ui/core/MenuList");
var Paper_1 = require("@material-ui/core/Paper");
var Popper_1 = require("@material-ui/core/Popper");
var styles_1 = require("@material-ui/core/styles");
var Switch_1 = require("@material-ui/core/Switch");
var Build_1 = require("@material-ui/icons/Build");
var Code_1 = require("@material-ui/icons/Code");
var Group_1 = require("@material-ui/icons/Group");
var withStyles_1 = require("@material-ui/styles/withStyles");
var camelCaseToTitle_1 = require("src/builder-reader/TextFormatters/camelCaseToTitle");
var styles = function (theme) { return styles_1.createStyles({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    nested: {
        paddingLeft: theme.spacing(4)
    },
    fab: {
        position: 'fixed',
        right: 0,
        top: 100,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        zIndex: 100
    },
    menu: {},
    paper: {
        boxShadow: '3 3 3 3 red'
    }
}); };
var options = [{
        option: 'prod',
        name: 'Production',
        control: React.createElement(Group_1.default, null)
    }, {
        option: 'canary',
        name: 'Canary',
        control: React.createElement(Build_1.default, null)
    }, {
        option: 'stag',
        name: 'Staging',
        control: React.createElement(Code_1.default, null)
    }];
// tslint:disable-next-line: max-classes-per-file
var EnvSettings = /** @class */ (function (_super) {
    __extends(EnvSettings, _super);
    function EnvSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: false };
        _this.anchorRef = React.createRef();
        /**
         * display env list options
         */
        _this.envOptionList = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement(ListSubheader_1.default, { component: "div" }, "BUILD"),
                React.createElement(MenuList_1.default, null, options.map(function (option) { return (React.createElement(MenuItem_1.default, { key: option.option, className: "env-option", selected: option.option === _this.props.selectedEnv, onClick: _this.handleEnvClick(option.option) },
                    option.control,
                    option.name)); }))));
        };
        /**
         * Render the feature flag list with flags and switch listener
         */
        _this.featureFlagList = function (_a) {
            var featureFlags = _a.featureFlags, onFeatureFlagClick = _a.onFeatureFlagClick;
            var featureFlagKeys = Object.keys(featureFlags);
            if (featureFlagKeys.length === 0) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(ListSubheader_1.default, { component: "div" }, "FEATURE FLAGS"),
                React.createElement(MenuList_1.default, null, featureFlagKeys.map(function (flagName) {
                    var flagValue = featureFlags[flagName];
                    var onChange = function () { return onFeatureFlagClick(flagName, !flagValue); };
                    return (React.createElement(MenuItem_1.default, { key: flagName, onClick: onChange },
                        React.createElement(Switch_1.default, { className: "feature-flag-switch", checked: flagValue, onChange: onChange, value: flagName, color: "primary", inputProps: { 'aria-label': 'secondary checkbox' } }),
                        camelCaseToTitle_1.default(flagName)));
                }))));
        };
        _this.handleEnvClick = function (selectedEnv) { return function () {
            _this.props.onEnvClick(selectedEnv);
        }; };
        _this.handleToggle = function () {
            _this.setState({ open: !_this.state.open });
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        return _this;
    }
    EnvSettings.prototype.render = function () {
        var _this = this;
        if (!this.props.isCanaryUser) {
            return null;
        }
        var classes = this.props.classes;
        var currentOption = options.find(function (o) { return o.option === _this.props.selectedEnv; }) ||
            options[2];
        var DisplayedIcon = currentOption && currentOption.control;
        return (React.createElement(ClickAwayListener_1.default, { onClickAway: this.handleClose },
            React.createElement(Grid_1.default, { container: true, direction: "column", alignItems: "center" },
                React.createElement(Grid_1.default, { item: true, xs: 12 },
                    React.createElement(Fab_1.default, { color: "primary", className: classes.fab, size: "large", "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-label": "select merge strategy", "aria-haspopup": "menu", onClick: this.handleToggle, ref: this.anchorRef }, DisplayedIcon),
                    React.createElement(Popper_1.default, { open: this.state.open, role: undefined, transition: true, disablePortal: true, anchorEl: this.anchorRef.current }, function (_a) {
                        var TransitionProps = _a.TransitionProps, placement = _a.placement;
                        return (React.createElement(Grow_1.default, __assign({}, TransitionProps, { style: {
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                            } }),
                            React.createElement(Paper_1.default, null,
                                React.createElement(_this.envOptionList, null),
                                React.createElement(_this.featureFlagList, { featureFlags: _this.props.featureFlags, onFeatureFlagClick: _this.props.onFeatureFlagClick }))));
                    })))));
    };
    return EnvSettings;
}(React.Component));
exports.default = withStyles_1.default(styles)(EnvSettings);
